import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Emoji } from './Emoji';
type CtaButtonProps = {
  children: React.ReactNode;
  emoji?: string;
  variant?: 'primary' | 'outline';
  href?: string;
  pulse?: boolean;
  className?: string;
};
export function CtaButton({
  children,
  emoji,
  variant = 'primary',
  href = '#plan-sistema-total',
  pulse = true,
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-2 rounded-full px-5 py-3.5 text-center font-display text-base font-extrabold uppercase tracking-tight sm:gap-2.5 sm:px-7 sm:py-4 transition-[background-color,color,border-color] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-celeste-600 focus-visible:ring-offset-2 focus-visible:ring-offset-white sm:text-lg';
  const variants = {
    primary: 'bg-celeste-600 text-white hover:bg-celeste-700',
    outline: 'border-2 border-celeste-400 text-celeste-700 hover:border-celeste-600 hover:bg-celeste-100'
  };
  return <a href={href} className={[base, variants[variant], pulse && variant === 'primary' ? 'cta-latente' : '', className].join(' ')} data-id="element-73" data-mp="35yqrz6psed1e">
      {emoji ? <Emoji symbol={emoji} data-id="element-74" data-mp="3ew9hanagrdj3" /> : null}
      <span className="text-[13px] sm:text-base" data-id="element-75" data-mp="3jwxig1separ1">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-76" data-mp="3jy8knx67eag1" />
    </a>;
}